export class EngineStrategyRemovedDto {
  constructor() {
    this.strategies = [];
  }

  strategies: { strategyId: string, dispositionId?: string }[];
}
